$(document).ready(function(){
  
    var winW = $(window).width();
	
	 $('#main-photo ul').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '#mini-photos ul'
	});
	$('#mini-photos ul').slick({
	  slidesToShow: 4,
	  slidesToScroll: 1,
      vertical: true,
	  asNavFor: '#main-photo ul',
	  dots: false,
	  arrows: false,
	  centerMode: false,
	  focusOnSelect: true,
      responsive: [
        {
          breakpoint: 830,
          settings: {
            vertical: false,
          }
        }
      ]
	});
	
	
	// Header
  
   /* if ( winW > 830 ) {
    
     $(window).scroll(function(){
      if ($(window).scrollTop() > 0) {
        $('header').addClass('fix');
      } else {
        $('header').removeClass('fix');
      }
    });
     
   } */
	
	$('header .icons li .search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});
  
    $('header .big-search .cerrar-big-search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});
	
	$('header .icons li .cart').click(function(){
		$('#minicart').addClass('show');	
	});
	$('#minicart .cerrar').click(function(){
		$('#minicart').removeClass('show');	
	});
	
	$('header .show-menu').click(function(){
		$('nav').addClass('show');
	});
	$('header nav .cerrar').click(function(){
		$('nav').removeClass('show');	
	});

  	// Product

    $('.product .deon > h3').each(function(){
      $(this).addClass('accor');
      $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
    })

    $('.product .deon h3').click(function(){
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });
  
  $('.featured-collection .item[data-id="5210287964298"]').remove();
  
    if ( winW < 830 ) {
      //$('nav ul.menu > li.site-nav--has-dropdown > a').removeAttr('href');
      
      $('nav ul.menu > li.site-nav--has-dropdown > a').each(function(){
        var href = $(this).attr('href');
        console.log('href: ' + href);
        
        $(this).click(function(e){
        	e.preventDefault();
            $(this).click(function(){
				//window.location.href = href;
            });
        });
        
      });
      
      $('nav ul.menu > li.site-nav--has-dropdown').click(function(){
        $(this).siblings().children('.sub-menu').removeClass('show');
        $(this).children('.sub-menu').toggleClass('show');
      });
    }
	
});
